import { Controller } from 'stimulus'
import { applyStickyTransforms } from '@helpers'

export default class extends Controller {
  connect() {
    this.element.addEventListener('scroll', () => applyStickyTransforms(this.element))
    applyStickyTransforms(this.element)
  }
}
